import React, { useState } from "react";
import { TopButs } from "./TopButs";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { Content } from "./Content";
import { LabelResultDrawer } from "./LabelResultDrawer";
import { LabelInfoDrawer } from "./LabelInfoDrawer";
export const FinishDiscernDetails = () => {
	const { getSelectedNavState } = useNavModel(() => []);
	const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);

	return (
		<>
			{detailsInfo && <>
				<TopButs {...detailsInfo} />
				<Content {...detailsInfo} />
				<LabelResultDrawer {...detailsInfo}/>
				<LabelInfoDrawer {...detailsInfo} />
			</>
			}
		</>
	)
}